import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './navigation-links1.css'

const NavigationLinks1 = (props) => {
  return (
    <nav className={`navigation-links1-nav ${props.rootClassName} `}>
      <Link to="/" className="navigation-links1-navlink">
        {props.text}
      </Link>
      <Link to="/la-spiaggia" className="navigation-links1-navlink1">
        {props.text1}
      </Link>
      <Link to="/servizi" className="navigation-links1-navlink2">
        {props.text2}
      </Link>
      <Link to="/chi-siamo" className="navigation-links1-navlink3">
        {props.text3}
      </Link>
    </nav>
  )
}

NavigationLinks1.defaultProps = {
  text3: 'Chi siamo',
  text: 'Home',
  text1: 'La spiaggia',
  rootClassName: '',
  text4: 'Blog',
  text2: 'Servizi',
}

NavigationLinks1.propTypes = {
  text3: PropTypes.string,
  text: PropTypes.string,
  text1: PropTypes.string,
  rootClassName: PropTypes.string,
  text4: PropTypes.string,
  text2: PropTypes.string,
}

export default NavigationLinks1
